import { isCustomizedType, reduce } from "et3-type-guards";
import { Ti18nKeys } from "../../constants/i18n";

import i18nServerResponse from "../../constants/i18n-server-response";
import { getDateAsObject } from "../../core/et3-date";
import { TReportAction, TTBWEventStats } from "../../Types";
import { post } from "../axios-post";

export const apiCallGetReportActionsAnalytics = async ({
  startDate,
  endDate
}: {
  startDate: Date;
  endDate: Date;
}): Promise<{
  data: {
    reportAction: TReportAction;
    tbwEventStats: TTBWEventStats;
  };
  status: string;
  code: Ti18nKeys;
}> => {
  const { status, data, et3Error } = await post<{
    reportAction: TReportAction;
    tbwEventStats: TTBWEventStats;
  }>(`auditor/getReportActionsAnalytics`, {
    startDateObject: getDateAsObject(startDate),
    endDateObject: getDateAsObject(endDate)
  });
  if (
    status === "OK" &&
    !isCustomizedType<{
      errorCode: string;
      et3Message: string;
    }>(
      {
        errorCode: "ERROR",
        et3Message: "ERROR"
      },
      data
    )
  ) {
    return {
      data: {
        reportAction: data.reportAction,
        tbwEventStats: data.tbwEventStats
      },
      status: "OK",
      code: "SUCCESS"
    };
  } else if (status === "ERROR") {
    const errorNumber = reduce(() => et3Error.errorNumber, 0);
    return {
      data: {
        reportAction: [],
        tbwEventStats: []
      },
      status: "ERROR",
      code: i18nServerResponse.get(errorNumber)
    };
  } else {
    return {
      data: {
        reportAction: [],
        tbwEventStats: []
      },
      status: "ERROR",
      code: "ERROR"
    };
  }
};
